import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { messages } from './ModalStates.messages';
export var Failure = function Failure(_ref) {
  var errorMessage = _ref.errorMessage,
      imageUrl = _ref.imageUrl,
      onModalClose = _ref.onModalClose,
      venueName = _ref.venueName;
  return React.createElement("div", {
    className: "reservation reservation--failed"
  }, imageUrl && React.createElement("div", {
    className: "modal__header modal__header__img pv++",
    style: {
      backgroundImage: "url(\"".concat(imageUrl, "\")")
    }
  }), React.createElement("div", {
    className: "reservation__header"
  }, React.createElement(FormattedMessage, messages.failed)), React.createElement("div", {
    className: "reservation__venue"
  }, venueName), errorMessage && React.createElement("p", {
    className: "reservation__error-message"
  }, errorMessage), React.createElement("button", {
    className: "bt bt--primary bt--lg mb+",
    onClick: onModalClose
  }, React.createElement(FormattedMessage, messages.done)));
};
Failure.propTypes = {
  errorMessage: PropTypes.string,
  imageUrl: PropTypes.string,
  onModalClose: PropTypes.func.isRequired,
  venueName: PropTypes.string.isRequired
};